import { render, staticRenderFns } from "./NewSale.vue?vue&type=template&id=5d1d3809"
import script from "./NewSale.vue?vue&type=script&lang=js"
export * from "./NewSale.vue?vue&type=script&lang=js"
import style0 from "./NewSale.vue?vue&type=style&index=0&id=5d1d3809&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports